// pages/sections/clientDataUtil.js
// Small pieces shared by the Client Data section and its modals.

import { useEffect, useState } from 'react';

// The on/off properties edited as checkboxes. `label` is the short form for the
// Flags column; `title` is the full name (tooltips, the bulk-edit form). `diOnly`: PE has no field
// for it, so it is stored in Data Integrity only — never "pending PE". `help` replaces `title` as
// the tooltip.
export const FLAGS = [
  { prop: 'isPaper',       label: 'Paper',     title: 'Is Paper' },
  { prop: 'isOrphan',      label: 'Orphan',    title: 'Orphan (Standalone)' },
  { prop: 'doNotOffshore', label: 'DNO',       title: 'DNO — Do Not Offshore' },
  { prop: 'postApril15',   label: 'Post 4/15', title: 'Post 4/15' },
  {
    prop: 'ownedByPe', label: 'Owned by PE', title: 'Owned by PE', diOnly: true,
    help: 'Check this box to indicate this client is owned by Private Equity. Saved in Data Integrity only — it is not sent to Practice Engine.',
  },
];

// US dollars; whole dollars unless `cents` is set.
export function formatMoney(n, { cents = false } = {}) {
  return (Number(n) || 0).toLocaleString('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: cents ? 2 : 0,
  });
}

// GET `url` once when it changes → { data, error }. Used by the on-demand modals.
export function useFetchJson(url) {
  const [state, setState] = useState({ data: null, error: '' });
  useEffect(() => {
    let live = true;
    setState({ data: null, error: '' });
    (async () => {
      try {
        const res = await fetch(url, { credentials: 'include' });
        const j = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(j.error || `HTTP ${res.status}`);
        if (live) setState({ data: j, error: '' });
      } catch (err) { if (live) setState({ data: null, error: err.message }); }
    })();
    return () => { live = false; };
  }, [url]);
  return state;
}
